import React from 'react'
import { object, string } from 'prop-types'

class FRParkingInformation extends React.Component {
  render () {
    const { productData = {}, id } = this.props
    if (!productData.name) return null
    const productPrice = productData.prices && productData.prices.per_week ? productData.prices.per_week : null

    return (
      <div id={id}>
        {productPrice && (
          <p>Parking 8 jours à partir du <span className='priceSpan' style={{ color: '#800080', fontSize: '24px' }}>&euro; {productPrice}</span></p>
        )}

        {productData.sellingpoint && (
          <h2 dangerouslySetInnerHTML={{ __html: productData.sellingpoint }} />
        )}

        {productData.transfer && [
          <h2 key='frProductInformation1Title'>Transfert:</h2>,
          <p key='frProductInformation1Content' dangerouslySetInnerHTML={{ __html: productData.transfer }} />
        ]}

        {productData.transferdauer && [
          <h2 key='frProductInformation2Title'>Heure de transfert:</h2>,
          <p key='frProductInformation2Content' dangerouslySetInnerHTML={{ __html: productData.transferdauer }} />
        ]}

        {productData.sicherheit && [
          <h2 key='frProductInformation3Title'>Sécurité:</h2>,
          <p key='frProductInformation3Content' dangerouslySetInnerHTML={{ __html: productData.sicherheit }} />
        ]}

        {productData.pkw_groesse && [
          <h2 key='frProductInformation4Title'>Dimensions maximales autorisées du véhicule:</h2>,
          <p key='frProductInformation4Content' dangerouslySetInnerHTML={{ __html: productData.pkw_groesse }} />
        ]}

        {productData.kindersitz && [
          <h2 key='frProductInformation5Title'>Siège enfant:</h2>,
          <p key='frProductInformation5Content' dangerouslySetInnerHTML={{ __html: productData.kindersitz }} />
        ]}

        {productData.bei_der_anreise_ && [
          <h2 key='frProductInformation6Title'>À l'arrivée:</h2>,
          <p key='frProductInformation6Content' dangerouslySetInnerHTML={{ __html: productData.bei_der_anreise_ }} />
        ]}

        {productData.bei_der_abreise && [
          <h2 key='frProductInformation7Title'>Au retour:</h2>,
          <p key='frProductInformation7Content' dangerouslySetInnerHTML={{ __html: productData.bei_der_abreise }} />
        ]}

        {productData.hinweis && [
          <h2 key='frProductInformation8Title'>Veuillez noter:</h2>,
          <p key='frProductInformation8Content' dangerouslySetInnerHTML={{ __html: productData.hinweis }} />
        ]}

        {productData.adresse && [
          <h2 key='frProductInformation9Title'>Adresse:</h2>,
          <p key='frProductInformation9Content' dangerouslySetInnerHTML={{ __html: productData.name }} />,
          <p key='frProductInformation10Content' dangerouslySetInnerHTML={{ __html: productData.adresse }} />
        ]}

        {productData.parkplatzbetreibertipp && (
          <div id='toptipbox'>
            <span className='toptipimage' />
            <h2>Conseils directement de l'aire de stationnement:</h2>
            <p dangerouslySetInnerHTML={{ __html: productData.parkplatzbetreibertipp }} />
          </div>
        )}
        <a className='pull-right' href='#top'>Haut de la page <i className='fa fa-arrow-circle-up' /></a>
      </div>
    )
  }
}

FRParkingInformation.propTypes = {
  productData: object,
  id: string
}

FRParkingInformation.defaultProps = {
  productData: { }
}

export default FRParkingInformation



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/fr-productInformation.jsx